module.exports = __webpack_public_path__ + "img/9788936456597.efe622e6.jpg";